import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import es from 'vuetify/lib/locale/es';
Vue.use(Vuetify);

export default new Vuetify({
	lang: {
		locales: { es },
		current: 'es',
	},
	icons: {
		iconfont: 'mdi',
	},
	breakpoint: {
		scrollBarWidth: 28,
	},
	theme: {
		themes: {
			light: {
				primary: '#db3005',
				secondary: '#7D4AFF',
				accent: '#f40b48',
			},
			dark: {
				primary: '#6A31FF',
				secondary: '#7D4AFF',
				accent: '#f40b48',
			},
		},
	},
});
